import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

const AddCOOSA2 = ({styles, handleSubmit, handleChange, args, errors}) => {
  return(
    <div>
      <button className="ui right labeled icon button" style={styles.titBuscar}>
        <i className="large plus yellow icon"></i>
        Categorías Observac OS Ab
      </button>
      <div style={styles.box}>
        <Form onSubmit={(ev)=>handleSubmit(ev, args)}>
          <div className="ui one column stackable grid">
            <div className="row container">
              <div className="column" width="100%">
                <Form.Field>
                  <label style={styles.label}>Descripción</label>
                  <Form.Input autoComplete="off" name="descrCOOSA" id="descrCOOSA" onChange={handleChange} placeholder='Categoría' icon={!errors.length?null: _find(errors, {path:'descrCOOSA'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>

                <Button style={styles.confirmar} type='submit' fluid>
                    AGREGAR
                </Button>

                {
                  errors.length?<Message negative header="Los siguientes errores:"
                  list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </div>
            </div>
          </div>
        </Form>
      </div>
    </div>
  )
}

export default AddCOOSA2
